import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = ({ increaseFontSize, decreaseFontSize, toggleContrast, fontSize, highContrast }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { path: '/', label: 'Início' },
    { path: '/focus-consultoria', label: 'Focus Consultoria e Treinamento Empresarial' },
    { path: '/focus-organiza', label: 'Focus Organiza' },
    { path: '/focus-coaching', label: 'Focus Coaching' },
    { path: '/focus-palestras', label: 'Focus Palestras' },
    { path: '/inscricao-blue-saude', label: 'Inscrição Blue Saúde' },
    { path: '/inscricao-depyl-express', label: 'Inscrição Depyl Express' },
    { path: '/treinamentos', label: 'Treinamentos' }
  ];

  return (
    <>
      {/* Skip Links para Acessibilidade */}
      <a href="#main-content" className="skip-link">
        Pular para o conteúdo principal
      </a>
      <a href="#navigation" className="skip-link">
        Pular para a navegação
      </a>
      
      <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg">
        {/* Faixa de Acessibilidade */}
      <div className="bg-focus-blue text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center">
          <div className="text-xs">
            <span>Acessibilidade:</span>
          </div>
          <div className="flex gap-2">
            <button
              onClick={decreaseFontSize}
              className="accessibility-btn"
              aria-label="Diminuir tamanho da fonte"
              disabled={fontSize === 'normal'}
            >
              A-
            </button>
            <button
              onClick={increaseFontSize}
              className="accessibility-btn"
              aria-label="Aumentar tamanho da fonte"
              disabled={fontSize === 'larger'}
            >
              A+
            </button>
            <button
              onClick={toggleContrast}
              className="accessibility-btn"
              aria-label={highContrast ? 'Desativar alto contraste' : 'Ativar alto contraste'}
            >
              {highContrast ? 'Contraste Normal' : 'Alto Contraste'}
            </button>
          </div>
        </div>
      </div>

      {/* Header Principal */}
      <div className="bg-focus-white py-4">
        <div className="container mx-auto px-4 flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center">
            <Link 
              to="/" 
              className="focus:outline-none focus:ring-2 focus:ring-focus-orange"
              aria-label="Focus Consultoria - Página inicial"
            >
              <img 
                src="/logo-focus.png" 
                alt="Focus Consultoria" 
                className="h-12 w-auto hover:opacity-80 transition-opacity"
              />
            </Link>
          </div>

          {/* Menu Desktop */}
          <nav className="hidden lg:flex space-x-6" id="navigation" role="navigation" aria-label="Menu principal">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-focus-orange focus:ring-offset-2 ${
                  location.pathname === item.path
                    ? 'text-focus-blue border-b-2 border-focus-blue'
                    : 'text-gray-700 hover:text-focus-blue'
                }`}
                aria-current={location.pathname === item.path ? 'page' : undefined}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Botão Menu Mobile */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:text-focus-blue hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-focus-orange focus:ring-offset-2"
            aria-expanded={isMenuOpen}
            aria-controls="mobile-menu"
            aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Menu Mobile */}
        {isMenuOpen && (
          <div id="mobile-menu" className="lg:hidden bg-focus-white border-t border-gray-200">
            <nav className="container mx-auto px-4 py-4 space-y-2" role="navigation" aria-label="Menu mobile">
              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block py-2 px-4 rounded transition-colors focus:outline-none focus:ring-2 focus:ring-focus-orange focus:ring-offset-2 ${
                    location.pathname === item.path
                      ? 'bg-focus-orange text-white'
                      : 'text-gray-700 hover:bg-focus-pink'
                  }`}
                  aria-current={location.pathname === item.path ? 'page' : undefined}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
    </>
  );
};

export default Header;